import {
    HttpResponse,
    ProductTypeModel,
    QueryModel,
    RequestParams,
    ProductTypeModelIEnumerableApiResultSuccess,
    ProductTypeModelApiResultSuccess,
    ApiResultFailed,
    Operation,
    FullRequestParams,
    AggregationModel,
    AggregationResponse,
    GrouppedQueryModel
} from "@/libs/Api";
import ApiService from "@/libs/core/api-service"
import {CrudDataQuery} from '@/libs/core/crud/crud-query';
import {CrudService, CrudListResponse, CrudResponse} from '@/libs/core/crud/crud-service';

export class ProductTypesDataService implements CrudService<ProductTypeModel, ProductTypeModel> {
    
    getAggregation(query: AggregationModel, params?: RequestParams): Promise<AggregationResponse> {
        throw new Error("Method not implemented.");
    }
    
    getGrouped(query: GrouppedQueryModel, params?: RequestParams): Promise<CrudResponse<any>> {
        throw new Error("Method not implemented.");
    }
    
    getAll(query: CrudDataQuery<ProductTypeModel>): Promise<CrudListResponse<ProductTypeModel>> {
        return ApiService.api.getProductTypeBatch(query.pageIndex, query.pageSize, <any>query.data, query.params);
    }

    get(id: string, params?: RequestParams): Promise<CrudResponse<ProductTypeModel>> {
        return ApiService.api.getProductTypeById(id, params);
    }

    create(item: ProductTypeModel, params?: RequestParams): Promise<CrudResponse<ProductTypeModel>> {
        return ApiService.api.insertProductType(item, params);
    }

    update(item: ProductTypeModel, params?: RequestParams): Promise<ProductTypeModel> {
        return ApiService.api.updateProductType(item.id as Required<string>, item, params).then((req: any) => req.data.returnValue);
    }

    partialUpdate(id: string, patches: Operation[], params?: RequestParams): Promise<ProductTypeModel> {
        return ApiService.api.patchProductType(id, patches).then((req: any) => req.data.returnValue);
    }

    delete(query: CrudDataQuery<ProductTypeModel>): Promise<CrudListResponse<ProductTypeModel>> {
        return ApiService.api.deleteProductTypes(<any>query.data, query.params).then((req: any) => req.data.returnValue);
    }

    download(query: CrudDataQuery<ProductTypeModel>): Promise<HttpResponse<any, ApiResultFailed | void>> {
        throw "NotImplemented";
    }

}
